
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schneehoehen-schneebericht",
      function () {
        return require("private-next-pages/schneehoehen-schneebericht.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/schneehoehen-schneebericht"])
      });
    }
  